import { hasToken } from "@/helpers/auth/";
import { isOnlyPublic } from "./helper";

const condition = ({ to }) => hasToken() && isOnlyPublic(to);
const whenTrue = ({ next }) => next("/");

export default [condition, whenTrue];
